import { memo } from 'react';
import cn from 'clsx';
import { Skeleton } from '@crehana/compass.ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PlayroomRewardCardSkeleton = function PlayroomRewardCardSkeleton(_ref) {
  var animated = _ref.animated,
    className = _ref.className,
    style = _ref.style;
  return /*#__PURE__*/_jsxs("article", {
    className: cn('tw-rounded-1.2',
    // Flex
    'tw-grid tw-gap-1.6 tw-grid-cols-1 sm:tw-grid-cols-2',
    // Shadow
    'tw-shadow-02 tw-shadow-neutral-light-100 dark:tw-shadow-neutral-dark-800',
    // Rounded
    'tw-rounded-1.2 tw-overflow-hidden', className),
    style: style,
    children: [/*#__PURE__*/_jsx(Skeleton, {
      animated: animated,
      className: "tw-w-full tw-h-full"
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-px-1.2 tw-py-2",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        animated: animated,
        className: "tw-w-14.4 tw-h-2.4 tw-mb-0.8 tw-rounded-1"
      }), /*#__PURE__*/_jsx(Skeleton, {
        animated: animated,
        className: "tw-w-24 tw-h-1.6 tw-mb-0.4 tw-rounded-1"
      }), /*#__PURE__*/_jsx(Skeleton, {
        animated: animated,
        className: "tw-w-28 tw-h-1.6 tw-mb-1.6 tw-rounded-1"
      }), /*#__PURE__*/_jsx(Skeleton, {
        animated: animated,
        className: "tw-w-5.6 tw-h-1.6 tw-mb-4 tw-rounded-1"
      }), /*#__PURE__*/_jsx(Skeleton, {
        animated: animated,
        className: "tw-w-full tw-h-3.6 tw-rounded-1"
      })]
    })]
  });
};
export default /*#__PURE__*/memo(PlayroomRewardCardSkeleton);